import { Link } from "react-router-dom";
import { articles, categories } from "@/mocks/news";

export default function CategorySection() {
  return (
    <section id="topics" className="mx-auto max-w-site px-4 py-14 md:px-6 md:py-16" aria-labelledby="topics-title">
      <div className="mb-8 text-center">
        <p className="text-xs font-medium tracking-[0.2em] text-primary-600">CATEGORIES</p>
        <h2 id="topics-title" className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
          主题分类
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600">
          按兴趣挑栏目，从明星动态到行业排播，找到你真正想追的那条线索。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((item, index) => {
          const count = articles.filter((a) => a.categorySlug === item.slug).length;
          return (
            <Link
              key={item.slug}
              to={`/category/${item.slug}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-background-100"
            >
              <span
                className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-md ${
                  index % 2 === 0
                    ? "bg-primary-100 text-primary-700"
                    : "bg-accent-100 text-accent-800"
                }`}
              >
                <i className={`${item.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <span className="min-w-0">
                <span className="flex items-center gap-2">
                  <span className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                    {item.name}
                  </span>
                  <span className="rounded-full bg-background-200 px-2 py-0.5 text-xs text-foreground-600">
                    {count} 条
                  </span>
                </span>
                <span className="mt-2 block text-sm leading-relaxed text-foreground-600">
                  {item.desc}
                </span>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-primary-600">
                  进入栏目
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true"></i>
                </span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}